// extracted by mini-css-extract-plugin
export var wrapper = "residency-module--wrapper--m2T2e";
export var slider = "residency-module--slider--Lb8KF";
export var slideInner = "residency-module--slideInner--KmCb1";
export var slideMore = "residency-module--slideMore--TLm9w";
export var slideLink = "residency-module--slideLink--FLLrq";
export var slideContentWrapper = "residency-module--slideContentWrapper--MXETk";
export var slideTitle = "residency-module--slideTitle--lRMfb";
export var slideContent = "residency-module--slideContent--jf3RP";
export var flag = "residency-module--flag--f96j4";